export const formatFileSize = (bytes = 0) => {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const splitFileName = (fileName = '', fileType = '') => {
  if (!fileType) return fileName;
  return fileName.substr(0, fileName.length - fileType.length - 1);
};
